<script setup lang="ts">
import moment from "moment";
import {defineProps, defineEmits, computed} from "vue";
import {IRequestCar} from "@/interfaces/IRequestCar";

const normalizeDate = (date: string, format: string) => {
  return moment(date).format(format);
}

const emits = defineEmits(['event:openRouteModal']);

const openRoute = (id: number) => {
  emits('event:openRouteModal', id)
};

// eslint-disable-next-line vue/valid-define-props
const props = defineProps<{ event: IRequestCar, statusFormat: Function | any }>();

const startDate = computed((): string => {
  if (props.event.technics) {
    // @ts-ignore
    return moment(props.event.technics[0].treads[0].start_date).format('HH:mm');
  }

  return '';
});

const endDate = computed((): string => {
  if (props.event.technics) {
    // @ts-ignore
    return moment(props.event.technics[0].treads[props.event.technics[0].treads.length - 1].end_date).format('HH:mm');
  }

  return ''
});

const companies = computed((): string => {
  return props.event.company
});

const departments = computed((): string => {
  return props.event.departments;
});

</script>
<template>
  <div class="card mb-3">
    <div class="card-body">
      <table class="table table-sm mb-2">
        <tbody>
        <tr>
          <td>№ Запроса</td>
          <td class="text-end">
            {{ props.event.id }}
          </td>
        </tr>
        <tr>
          <td>Статус</td>
          <td class="text-end">
            <span class="badge bg-warning">{{ props.statusFormat(props.event.status) }}</span>
          </td>
        </tr>
        <tr>
          <td>Подтверждение</td>
          <td class="text-end">
            <template v-if="props.event.partnerAgreeDate">
              <span class="badge bg-success">
                Вы подтвердили объемы
              </span>
            </template>
            <template v-else>
              <span class="badge bg-secondary">Объемы не подтверждены</span>
            </template>
          </td>
        </tr>
        <tr>
          <td>Дата</td>
          <td class="text-end">
            {{ normalizeDate(props.event.date, 'DD.MM.YYYY') }}
          </td>
        </tr>
        <tr>
          <td>Техника</td>
          <td class="text-end">
            {{ props.event.technics.length ? (props.event.technics[0].car?.car_name || props.event.carTypeName) : '' }}
          </td>
        </tr>

        <tr>
          <td>Предприятие</td>
          <td class="text-end" v-html="companies" />
        </tr>

        <tr>
          <td>Участок</td>
          <td class="text-end" v-html="departments" />
        </tr>

        <tr>
          <td>Время</td>

          <td class="text-end">
            {{ startDate }} - {{ endDate }}
          </td>
        </tr>


        <tr>
          <td>Маршрут</td>

          <td class="text-end" style="font-size: 12px">
            <a @click="openRoute(props.event.id)" href="javascript:void(0)" class="text-decoration-none fs-6">
              Нажмите для просмотра
            </a>
          </td>
        </tr>
        </tbody>
      </table>

      <router-link :to="{name: 'event', params: {id: props.event.id}}">
        <button type="button" class="btn btn-primary w-100">
          Открыть
        </button>
      </router-link>
    </div>
  </div>
</template>
